// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { IS_DEVELOPMENT } from "../../../../../../io/hyperify/core/constants/environment";
import { Loader } from "../../../../../../io/hyperify/frontend/components/loader/Loader";
import { useQueryParam } from "../../../../../../io/hyperify/frontend/hooks/useQueryParams";
import {
    AGENT_FACEBOOK_ROUTE,
} from "../../../../core/constants/route";
import { AGENT_FACEBOOK_VIEW_CLASS_NAME } from "../../../../core/constants/className";
import {
    T_AGENT_FACEBOOK_VIEW_DESCRIPTION,
    T_AGENT_FACEBOOK_VIEW_TITLE,
    T_SITE_NAME,
} from "../../../../core/constants/translation";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import { SEODiv } from "../../common/seo/SEODiv";
import "./AgentFacebookView.scss";

export interface AgentFacebookViewProps {
    readonly t : TranslationFunction;
}

export function AgentFacebookView (props: AgentFacebookViewProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);

    // Use one item by random as the default seo image featured item
    const [code, ] = useQueryParam('code', '');

    return (
        <SEODiv className={AGENT_FACEBOOK_VIEW_CLASS_NAME}
                path={AGENT_FACEBOOK_ROUTE}
                title={t(T_AGENT_FACEBOOK_VIEW_TITLE)}
                description={t(T_AGENT_FACEBOOK_VIEW_DESCRIPTION)}
                siteName={t(T_SITE_NAME)}
        >

            <article>

                <h3>{t(T_AGENT_FACEBOOK_VIEW_TITLE)}</h3>

                <p>{t(T_AGENT_FACEBOOK_VIEW_DESCRIPTION)}</p>

                {!code ? (
                    <Loader />
                ) : (
                    IS_DEVELOPMENT ? (
                        <pre>LOG_LEVEL=DEBUG node dist/agent.js facebook submit-code '{code}'</pre>
                    ) : (
                        <pre>nor-agent facebook submit-code '{code}'</pre>
                    )
                )}

            </article>

        </SEODiv>
    );
}
